export default __webpack_public_path__ + "static/media/IT_Track.c220ade0.svg";